/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home2.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/page2',
                name: 'page-2',
                component: () => import('./views/Page2.vue')
              },
              {
                path: '/pasien/list',
                name: 'patient-list',
                component: () => import('@/views/pages/patient-management/list/PatientList.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/pasien/create',
                name: 'patient-create',
                component: () => import('@/views/pages/patient-management/create/CreatePatient.vue'),
                meta: {
                  rule: 'admin',
                  parent: 'pasien'
                },
              },
              {
                path: '/patient/timeline',
                name: 'patient-timeline',
                component: () => import('@/views/pages/patient-management/PatientTimeline.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/patient/visit',
                name: 'patient-visit',
                component: () => import('@/views/pages/patient-management/PatientVisit.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/covid/swab',
                name: 'covid-swab',
                component: () => import('@/views/pages/covid/list/SwabList.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/covid/swab/create',
                name: 'covid-swab-create',
                component: () => import('@/views/pages/covid/create/SwabCreate.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/covid/thorax',
                name: 'covid-thorax',
                component: () => import('@/views/pages/covid/list/ThoraxList.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/antrian/klinik/list',
                name: 'antrian-klinik',
                component: () => import('@/views/pages/lab/list/QueueClinic.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/antrian/pcr/list',
                name: 'antrian-pcr',
                component: () => import('@/views/pages/lab/list/QueuePCR.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/specimen/klinik/list',
                name: 'specimen-klinik',
                component: () => import('@/views/pages/lab/list/SpecimenClinic.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/specimen/pcr/list',
                name: 'specimen-pcr',
                component: () => import('@/views/pages/lab/list/SpecimenPCR.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/worklist/klinik',
                name: 'worklist-klinik',
                component: () => import('@/views/pages/lab/list/WorkListClinic.vue'),
                meta: {
                    rule: 'admin',
                    authRequired: true
                },
              },
              {
                path: '/worklist/pcr',
                name: 'worklist-pcr',
                component: () => import('@/views/pages/lab/list/WorkListPCR.vue'),
                meta: {
                    rule: 'admin',
                    authRequired: true
                },
              },
              {
                path: '/clinic/pdf',
                name: 'clinic-pdf',
                component: () => import('@/pdf/ContentClinic.vue'),
                meta: {
                    rule: 'admin',
                    authRequired: true
                },
              },
              {
                path: '/clinic/pdf/print',
                name: 'clinic-pdf-print',
                component: () => import('@/pdf/ContentClinicPrint.vue'),
                meta: {
                    rule: 'admin',
                    authRequired: true
                },
              },
              {
                path: '/pcr/pdf',
                name: 'pcr-pdf',
                component: () => import('@/pdf/ContentPCR.vue'),
                meta: {
                    rule: 'admin',
                    authRequired: true
                },
              },
              {
                path: '/kwitansi/pdf',
                name: 'kwitansi-pdf',
                component: () => import('@/pdf/Kwitansi.vue'),
                meta: {
                    rule: 'admin',
                    authRequired: true
                },
              },
              {
                path: '/worklist/start/:id',
                name: 'worklist-start',
                component: () => import('@/views/pages/lab/create/WorklistStart.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/worklist/entry/:id',
                name: 'worklist-entry',
                component: () => import('@/views/pages/lab/create/WorklistEntry.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/worklist/verify/:id',
                name: 'worklist-verify',
                component: () => import('@/views/pages/lab/create/WorklistVerify.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/worklist/valid/:id',
                name: 'worklist-valid',
                component: () => import('@/views/pages/lab/create/WorklistValidation.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/worklist/delete/:id',
                name: 'worklist-delete',
                component: () => import('@/views/pages/lab/create/WorklistDelete.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/statistic-cards',
                name: 'statistic-cards',
                component: () => import('@/components/statistics-cards/StatisticsCardLine.vue'),
                meta: {
                  rule: 'admin',
                },
              },
              {
                path: '/order/klinik',
                name: 'order-klinik',
                component: () => import('@/views/pages/lab/create/OrderClinic.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/order/pcr',
                name: 'order-pcr',
                component: () => import('@/views/pages/lab/create/OrderPCR.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/list',
                name: 'user-list',
                component: () => import('@/views/pages/user/user/ListUser.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/edit/:id',
                name: 'user-edit',
                component: () => import('@/views/pages/user/user/CreateUser.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/create',
                name: 'user-create',
                component: () => import('@/views/pages/user/user/CreateUser.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/role/list',
                name: 'user-role-list',
                component: () => import('@/views/pages/user/role/ListRole.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/role/edit/:id',
                name: 'user-role-edit',
                component: () => import('@/views/pages/user/role/CreateRole.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/role/create',
                name: 'user-role-create',
                component: () => import('@/views/pages/user/role/CreateRole.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/lab/bagianlab/list',
                name: 'pemeriksaan-bagianlab-list',
                component: () => import('@/views/pages/lab/bagianlab/ListBagianLab.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/lab/bagianlab/edit/:id',
                name: 'pemeriksaan-bagianlab-edit',
                component: () => import('@/views/pages/lab/bagianlab/CreateBagianLab.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/lab/bagianlab/create',
                name: 'lab-bagianlab-create',
                component: () => import('@/views/pages/lab/bagianlab/CreateBagianLab.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/grouptest/list',
                name: 'pemeriksaan-grouptest-list',
                component: () => import('@/views/pages/lab/grouptest/ListGroupTest.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/grouptest/edit/:id',
                name: 'pemeriksaan-grouptest-edit',
                component: () => import('@/views/pages/lab/grouptest/CreateGroupTest.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/grouptest/create',
                name: 'pemeriksaan-grouptest-create',
                component: () => import('@/views/pages/lab/grouptest/CreateGroupTest.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/measure/list',
                name: 'pemeriksaan-measure-list',
                component: () => import('@/views/pages/lab/measure/ListMeasure.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/measure/edit/:id',
                name: 'pemeriksaan-measure-edit',
                component: () => import('@/views/pages/lab/measure/CreateMeasure.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
			  
              {
                path: '/pemeriksaan/measure/setting',
                name: 'pemeriksaan-measure-setting',
                component: () => import('@/views/pages/lab/measure/ListMeasureSetting.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/panel/list',
                name: 'pemeriksaan-panel-list',
                component: () => import('@/views/pages/lab/measure/ListPanel.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/panel/edit/:id',
                name: 'pemeriksaan-panel-edit',
                component: () => import('@/views/pages/lab/measure/CreatePanel.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/nilaireagen/list',
                name: 'pemeriksaan-nilaireagen-list',
                component: () => import('@/views/pages/lab/nilaireagen/ListNilaiReagen.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/nilaireagen/create',
                name: 'pemeriksaan-nilaireagen-create',
                component: () => import('@/views/pages/lab/nilaireagen/CreateNilaiReagen.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/nilaireagen/edit/:id',
                name: 'pemeriksaan-nilaireagen-edit',
                component: () => import('@/views/pages/lab/nilaireagen/CreateNilaiReagen.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/harga/list',
                name: 'pemeriksaan-harga-list',
                component: () => import('@/views/pages/lab/measure/ListHargaPemeriksaan.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/harga/create',
                name: 'pemeriksaan-harga-create',
                component: () => import('@/views/pages/lab/measure/CreateHargaPemeriksaan.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/harga/edit/:id',
                name: 'pemeriksaan-harga-edit',
                component: () => import('@/views/pages/lab/measure/CreateHargaPemeriksaan.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/instrument/list',
                name: 'pemeriksaan-instrument-list',
                component: () => import('@/views/pages/lab/instrument/ListInstrument.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/instrument/create',
                name: 'pemeriksaan-instrument-create',
                component: () => import('@/views/pages/lab/instrument/CreateInstrument.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/instrument/edit/:id',
                name: 'pemeriksaan-instrument-edit',
                component: () => import('@/views/pages/lab/instrument/CreateInstrument.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/pemeriksaan/instrument/lot/:id',
                name: 'pemeriksaan-instrument-lot',
                component: () => import('@/views/pages/lab/instrument/CreateLotInstrument.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true
                },
              },
              {
                path: '/user/settings',
                name: 'user-settings',
                component: () => import('./views/pages/user/settings/Settings.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'User' },
                    { title: 'User Settings', active: true },
                  ],
                  pageTitle: 'Settings'
                },
              },
              {
                path: '/stock/purchase',
                name: 'purchase',
                component: () => import('./views/pages/stock/ListPurchase.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/stock/purchase/create',
                name: 'purchase-create',
                component: () => import('./views/pages/stock/CreatePurchase.vue'),
                meta: {
                  rule: 'admin',
                  parent: 'purchaseorder',
                },
              },
              {
                path: '/stock/purchase/view',
                name: 'purchase-view',
                component: () => import('./views/pages/stock/ViewPurchase.vue'),
                meta: {
                  rule: 'admin',
                  parent: 'purchaseorder',
                },
              },
              {
                path: '/stock/purchase/receive/:id',
                name: 'purchase-receive',
                component: () => import('./views/pages/stock/ReceivePurchase.vue'),
                meta: {
                  rule: 'admin',
                  parent: 'purchaseorder',
                },
              },
              {
                path: '/stock/warehouse',
                name: 'warehouse',
                component: () => import('./views/pages/stock/ListStock.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/stock/usage',
                name: 'stock-setting',
                component: () => import('./views/pages/stock/ListStockSetting.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/stock/usage/entry/:id',
                name: 'stock-usage-entry',
                component: () => import('@/views/pages/stock/UsageEntry.vue'),
                meta: {
                    rule: 'admin',
                },
              },
              {
                path: '/inventory/supplier',
                name: 'list-supplier',
                component: () => import('./views/pages/supplier/ListSupplier.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/supplier/create',
                name: 'create-supplier',
                component: () => import('./views/pages/supplier/CreateSupplier.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-supplier",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/supplier/edit/:id',
                name: 'edit-supplier',
                component: () => import('./views/pages/supplier/CreateSupplier.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-supplier",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/produk',
                name: 'list-produk',
                component: () => import('./views/pages/produk/ListProduk.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/produk/create',
                name: 'create-produk',
                component: () => import('./views/pages/produk/CreateProduk.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-produk",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/produk/edit/:id',
                name: 'edit-produk',
                component: () => import('./views/pages/produk/CreateProduk.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-produk",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/uom',
                name: 'list-uom',
                component: () => import('./views/pages/uom/ListUOM.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/uom/create',
                name: 'create-uom',
                component: () => import('./views/pages/uom/CreateUOM.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-uom",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/uom/edit/:id',
                name: 'edit-uom',
                component: () => import('./views/pages/uom/CreateUOM.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-uom",
                  authRequired: true,
                },
              },              
              {
                path: '/inventory/produk/group',
                name: 'list-produk-group',
                component: () => import('./views/pages/produk/ListProdukGroup.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/produk/group/create',
                name: 'create-produk-group',
                component: () => import('./views/pages/produk/CreateProdukGroup.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-produk-group",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/produk/group/edit/:id',
                name: 'edit-produk-group',
                component: () => import('./views/pages/produk/CreateProdukGroup.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-produk-group",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/suhu',
                name: 'list-suhu',
                component: () => import('./views/pages/inventory/suhu/ListSuhu.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/suhu/create',
                name: 'create-suhu',
                component: () => import('./views/pages/inventory/suhu/CreateSuhu.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-suhu",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/suhu/edit/:id',
                name: 'edit-suhu',
                component: () => import('./views/pages/inventory/suhu/CreateSuhu.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-suhu",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/lokasi',
                name: 'list-lokasi',
                component: () => import('./views/pages/inventory/lokasi/ListLokasi.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/lokasi/create',
                name: 'create-lokasi',
                component: () => import('./views/pages/inventory/lokasi/CreateLokasi.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-lokasi",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/lokasi/edit/:id',
                name: 'edit-lokasi',
                component: () => import('./views/pages/inventory/lokasi/CreateLokasi.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-lokasi",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/klasifikasi',
                name: 'list-klasifikasi',
                component: () => import('./views/pages/inventory/klasifikasi/ListKlasifikasi.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/klasifikasi/create',
                name: 'create-klasifikasi',
                component: () => import('./views/pages/inventory/klasifikasi/CreateKlasifikasi.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-klasifikasi",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/klasifikasi/edit/:id',
                name: 'edit-klasifikasi',
                component: () => import('./views/pages/inventory/klasifikasi/CreateKlasifikasi.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-lokasi",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/volume',
                name: 'list-volume',
                component: () => import('./views/pages/inventory/volume/ListVolume.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/inventory/volume/create',
                name: 'create-volume',
                component: () => import('./views/pages/inventory/volume/CreateVolume.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-volume",
                  authRequired: true,
                },
              },
              {
                path: '/inventory/volume/edit/:id',
                name: 'edit-volume',
                component: () => import('./views/pages/inventory/volume/CreateVolume.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-volume",
                  authRequired: true,
                },
              },                                                        
              {
                path: '/lab/setting/edit',
                name: 'edit-lab-setting',
                component: () => import('./views/pages/lab/setting/CreateSetting.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/lab/dokter/list',
                name: 'list-lab-dokter',
                component: () => import('./views/pages/lab/dokter/ListDokter.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/lab/dokter/create',
                name: 'create-lab-dokter',
                component: () => import('./views/pages/lab/dokter/CreateDokter.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/lab/dokter/edit/:id',
                name: 'edit-lab-dokter',
                component: () => import('./views/pages/lab/dokter/CreateDokter.vue'),
                meta: {
                  rule: 'admin',
                  parent: "list-produk-group",
                  authRequired: true,
                },
              },
              {
                path: '/lab/ruangan/list',
                name: 'list-lab-ruangan',
                component: () => import('./views/pages/lab/ward/ListRuangan.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/lab/ruangan/create',
                name: 'create-lab-ruangan',
                component: () => import('./views/pages/lab/ward/CreateRuangan.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/lab/ruangan/edit/:id',
                name: 'edit-lab-ruangan',
                component: () => import('./views/pages/lab/ward/CreateRuangan.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
              {
                path: '/report/patient/visit',
                name: 'report-patient-visit',
                component: () => import('./views/pages/report/ByVisit.vue'),
                meta: {
                  rule: 'admin',
                  authRequired: true,
                },
              },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue'),
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
              {
                path: '/pages/error-500',
                name: 'page-error-500',
                component: () => import('@/views/pages/Error500.vue'),
              },
              {
                path: '/pages/logout',
                name: 'page-logout',
                component: () => import('@/views/pages/Logout.vue'),

              },
              {
                path: '/pages/not-authorized',
                name: 'page-not-authorized',
                component: () => import('@/views/pages/NotAuthorized.vue'),
              },
              {
                path: '/pages/maintenance',
                name: 'page-maintenance',
                component: () => import('@/views/pages/Maintenance.vue'),
              },
              {
                path: '/pdf/:id/:id1',
                name: 'pdf',
                component: () => import('@/pdf/ContentOutPrint.vue'),
              },
            ]
        },
        {
            path: '',
            component: () => import('@/layouts/openimage/Main.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/pages/openimagehealth',
                    name: 'page-openimagehealth',
                    component: () => import('@/views/pages/openimagehealth/Preview.vue'),
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  const user = store.state.AppActiveUser;
  //console.log(to.meta);
  if (to.meta.authRequired) {
    if (user.token != null) {
      next();
    } else {
      next({ path: '/pages/login', query: { to: to.path, id: to.query.id } });
    }
  } else {
    next();
  }
});
export default router
